<template>
    <fixed-header :fixed.sync="isFixed">
        <header :class="[{ 'is-fixed': isFixed && !isHomepage }, 'header']">
            <div class="header-brand">
                <button class="header-brand-menuButton" @click="openMenu">
                    <span class="visuallyHide_mobile header-brand-menuButton-text">
                        Menu
                    </span>
                    <i class="icon icon_menu"></i>
                </button>
                <a href="/" data-label="home page link" class="header-brand-link">
                    <svg width="186px" height="39px" viewBox="0 0 186 39" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="header-brand-link-logo">
                        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Header" transform="translate(-108.000000, -5.000000)" fill="#FFFFFF">
                                <g id="Kohler-Logo" transform="translate(107.000000, 5.000000)">
                                    <g id="Group-2" transform="translate(1.728972, 0.000000)">
                                        <polygon id="Fill-1" points="100.852116 36.9124031 100.852116 1.05068438 111.042322 1.05068438 111.042322 27.7474031 122.480644 27.7474031 122.480644 36.9124031"></polygon>
                                        <polygon id="Fill-2" points="67.6498116 36.9124031 67.6498116 1.05068438 77.8400171 1.05068438 77.8400171 13.6257469 88.1151199 13.6257469 88.1151199 1.05068438 98.3053253 1.05068438 98.3053253 36.9124031 88.1151199 36.9124031 88.1151199 23.5719656 77.8400171 23.5719656 77.8400171 36.9124031"></polygon>
                                        <polygon id="Fill-3" points="33.0263014 1.05604687 18.3035959 18.1343906 35.1259247 36.9250781 21.6386644 36.9189844 10.2117466 24.1257656 10.1889384 24.1257656 10.1889384 36.9128906 0 36.9128906 0 1.05117187 10.1889384 1.05117187 10.1889384 11.7920156 10.1091096 11.8017656 19.815274 1.05604687"></polygon>
                                        <g id="Group-13" transform="translate(26.608955, 0.000000)">
                                            <path d="M20.1233116,27.8756156 C24.9029007,27.8756156 28.7764966,23.7574594 28.7764966,18.6764906 C28.7764966,13.5967406 24.9029007,9.47858437 20.1233116,9.47858437 C15.3437226,9.47858437 11.4701267,13.5967406 11.4701267,18.6764906 C11.4701267,23.7574594 15.3437226,27.8756156 20.1233116,27.8756156 M0.898517123,18.6838031 C0.898517123,8.36586563 9.50608562,0.000365625 20.1233116,0.000365625 C30.7405377,0.000365625 39.3481062,8.36586563 39.3481062,18.6838031 C39.3481062,29.0029594 30.7405377,37.3672406 20.1233116,37.3672406 C9.50608562,37.3672406 0.898517123,29.0029594 0.898517123,18.6838031" id="Fill-4"></path>
                                            <polygon id="Fill-6" points="108.182425 1.05117187 118.651397 1.05117187 118.651397 9.31307812 108.420644 9.33379687 108.383897 14.9948906 117.836637 14.9948906 117.836637 23.0227969 108.397836 23.0227969 108.405438 28.4962031 118.740096 28.4962031 118.740096 36.9128906 108.271123 36.9128906 97.9656096 36.9128906 97.9656096 1.05117187"></polygon>
                                            <path d="M133.855736,16.2673875 C135.838784,16.2673875 137.446764,14.7207937 137.446764,12.81345 C137.446764,10.9061062 135.838784,9.3595125 133.855736,9.3595125 L130.967962,9.3595125 L130.967962,16.2588562 L133.855736,16.2673875 Z M139.837825,22.5817312 L150.441113,36.9312937 L139.313236,36.9130125 L131.003442,25.9040437 L131.003442,36.891075 L121.019777,36.891075 L121.019777,1.0378875 L133.793647,1.0378875 C145.033031,1.0378875 152.165668,14.6001375 139.837825,22.5817312 Z" id="Fill-8"></path>
                                            <g id="Group-12" transform="translate(150.787671, 30.468750)">
                                                <path d="M4.61575,4.08780937 C5.00602397,4.08780937 5.22650342,4.00615312 5.22650342,3.58202812 C5.22650342,3.23955937 4.77667466,3.23955937 4.43708562,3.23955937 L3.68188014,3.23955937 L3.68188014,4.08780937 L4.61575,4.08780937 Z M5.85499658,6.01465312 L5.00602397,6.01465312 L4.22547603,4.59359062 L3.68188014,4.59359062 L3.68188014,6.01465312 L2.90133219,6.01465312 L2.90133219,2.65090312 L4.5992774,2.65090312 C5.40516781,2.65090312 5.95636644,2.78984062 5.95636644,3.67952812 C5.95636644,4.29987187 5.62564726,4.55337187 5.00602397,4.59359062 L5.85499658,6.01465312 Z M6.80533904,4.37421562 C6.80533904,2.92024687 5.68520205,1.89162187 4.24194863,1.89162187 C2.77335274,1.89162187 1.67855822,2.92024687 1.67855822,4.37421562 C1.67855822,5.80990312 2.77335274,6.83852812 4.24194863,6.83852812 C5.68520205,6.83852812 6.80533904,5.80990312 6.80533904,4.37421562 Z M0.881537671,4.37421562 C0.881537671,2.56924687 2.36660616,1.12380937 4.24194863,1.12380937 C6.10968836,1.12380937 7.60235959,2.56924687 7.60235959,4.37421562 C7.60235959,6.16090312 6.10968836,7.60634062 4.24194863,7.60634062 C2.36660616,7.60634062 0.881537671,6.16090312 0.881537671,4.37421562 Z" id="Fill-10"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </a>
            </div>
            <div class="header-search">
                <button class="header-search-button" @click="openSearch">
                    <span class="visuallyHide_mobile vr_2">
                        Search
                    </span>
                    <i class="icon icon_search icon_search_light"></i>
                </button>
            </div>
            <transition name="v-fade">
                <menu-screen v-if="menuIsOpen" v-bind="{ menuIsOpen, menuItems, secondaryMenuItems, socialLinks, regionsEnabled, regions, regionAction }" v-on:closeMenu="closeMenu"></menu-screen>
            </transition>
            <transition name="v-fade">
                <search-screen v-if="searchIsOpen" v-on:closeSearch="closeSearch" theme="light"></search-screen>
            </transition>
        </header>
    
        </fixed-header>
    </template>

<script>
import FixedHeader from 'vue-fixed-header';
import MenuScreen from './MenuScreen.vue';
import SearchScreen from './SearchScreen.vue';

export default {
    props: ['menu-items', 'secondary-menu-items', 'social-links', 'regionsEnabled',  'regions', 'regionAction', 'isHomepage'],
    data() {
        return {
            isFixed: false,
            menuIsOpen: false,
            searchIsOpen: false,
            storedY: 0,
        }
    },
    components: {
        FixedHeader,
        MenuScreen,
        SearchScreen
    },
    methods: {
        openMenu() {
            this.fixBody();
            this.menuIsOpen = true;
        },
        closeMenu() {
            this.freeBody();
            this.menuIsOpen = false;
        },
        openSearch() {
            this.fixBody();
            this.searchIsOpen = true;
        },
        closeSearch() {
            this.freeBody();
            this.searchIsOpen = false;
        },
        fixBody() {
            this.storedY = window.scrollY;
            document.documentElement.setAttribute(
                "style",
                `position: fixed; top: ${-1 *
                window.scrollY}px; height: 100%; width: 100%; overflow-y: scroll;`
            );
        },
        freeBody() {
            document.documentElement.setAttribute(
                "style",
                `position: relative; overflow-y: scroll;`
            );
            window.scroll(0, this.storedY);
        },

    }
}
</script>

<style lang="scss">
</style>